module.exports = __webpack_public_path__ + "static/media/sx.5b091a5e.svg";